import { useEffect, useRef, useState } from 'react'

const THINKING_MESSAGES = [
  'Thinking...',
  'Reading the docs...',
  'Tracing the call graph...',
  'Reasoning about your endpoint...',
  'Composing the logic...',
  'Checking the policy...',
  'Mapping the API surface...',
  'Wrangling some data...',
  'Considering edge cases...',
  'Measuring twice, coding once...',
  'Running the numbers...',
  'Connecting the dots...',
  'Reviewing the plan...',
  'Almost there...'
]

const ROTATION_INTERVAL_MS = 3000

/**
 * Cycles through fun status messages while active.
 * Returns the static `override` when provided (e.g. a specific tool message),
 * otherwise rotates through THINKING_MESSAGES.
 */
export function useRotatingMessage (active, override) {
  const [index, setIndex] = useState(0)
  const intervalRef = useRef(null)

  useEffect(() => {
    if (!active || override) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
      setIndex(0)
      return
    }

    intervalRef.current = setInterval(() => {
      setIndex(prev => (prev + 1) % THINKING_MESSAGES.length)
    }, ROTATION_INTERVAL_MS)

    return () => clearInterval(intervalRef.current)
  }, [active, override])

  if (!active) return null
  if (override) return override
  return THINKING_MESSAGES[index]
}
